import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';

const ConfirmTransactionDialog = ({
  handleCancel,
  handleConfirm,
  mlxAmount,
  open,
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>{'Create Poll'}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          {`Pay ${mlxAmount.toLocaleString('en-US')} to create the poll.`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button variant='outlined' onClick={handleConfirm} autoFocus>
          Pay
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmTransactionDialog.propTypes = {
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func,
  mlxAmount: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired
}

export default ConfirmTransactionDialog;